module.exports = __webpack_public_path__ + "img/red-hammock-inside-room-3263716.6433ed66.jpg";